<template>

    <div id="app" class="container-fluid ">
        <div class="row justify-content-center mb-5 ">
            <el-date-picker
                    v-model="dates"
                    type="daterange"
                    range-separator="a"
                    start-placeholder="Fecha de inicio"
                    end-placeholder="Fecha de fin">
            </el-date-picker>
        </div>
        <div class="row d-flex justify-content-around align-items-center mb-5">
            <div class="col-12 col-lg-4">
                <h5 class="text-muted">{{ 'Tickets resueltos' + amountOfTickets }} </h5>
                <ticketsProportions :tickets="ticketsGroupedByType"
                                    :style="'height:' + (ticketsGroupedByType.length * 40).toString() + 'px; min-height:40px' "
                                    v-loading="loading"></ticketsProportions>
            </div>
            <div class="col-12 col-lg-6">
                <ticketsHistory :unresolved-tickets="unresolvedTickets" :tickets-in-level3="ticketsGroupedByDate"
                                v-loading="loading"></ticketsHistory>
            </div>
        </div>
        <div class="row justify-content-start">
            <div class="col-1">
                <el-button type="text" @click="toggleTable()">{{(showTable? '-':'+') + ' detalles'}}</el-button>
            </div>
        </div>
        <div class="row justify-content-around align-items-center mt-5" v-if="showTable">
            <div class="col col-lg-9">
                <h5 class="text-muted">Detalle de tickets resueltos</h5>
                <ticketTable :tickets="tickets" v-loading="loading"></ticketTable>
            </div>
        </div>
    </div>
</template>

<script>
    import ticketsHistory from "../components/ticketsHistory";
    import ticketsProportions from "./../components/ticketsProportions";
    import ticketTable from "../components/ticketTable";
    import Axios from "../utils/http/Axios";

    export default {
        name: 'tickets',
        components: {
            ticketsProportions, ticketsHistory, ticketTable
        },
        data() {
            return {
                groupedTickets: [],
                tickets: [],
                unresolvedTickets: [],
                loading: false,
                dates: '',
                showTable: false
            }
        },
        computed: {
            amountOfTickets: function () {
                let sum = 0;
                this.ticketsGroupedByType.forEach(t => {
                    sum += t.count;
                })
                return sum === 0 ? "" : " (" + sum + ")"
            },
            ticketsGroupedByType: function () {
                let grouped = {};
                this.tickets.filter(t => t.user === 'SUPPORT').forEach(value => {
                    let ticketType = value.type;
                    if (grouped[ticketType] !== undefined) {
                        grouped[ticketType].count = grouped[ticketType].count + 1
                    } else {

                        grouped[ticketType] = {count: 1, type: ticketType};
                    }
                })
                return Object.values(grouped)
            },
            ticketsGroupedByDate: function () {
                let grouped = {};
                this.tickets.forEach(value => {
                    let date = new Date(value.timestamp);
                    date.setHours(0, 0, 0);
                    let datestr = date.toISOString().substring(0, 10);

                    if (grouped[datestr] !== undefined) {
                        grouped[datestr].y = grouped[datestr].y + 1
                    } else {
                        grouped[datestr] = {y: 1, x: date.getTime()};
                    }
                })
                return Object.values(grouped)
            }
        },
        watch: {
            dates: function (newVal) {
                let startDate = newVal[0];
                let endDate = newVal[1];
                this.loading = true;
                Axios.getInstance().get('/api/tickets?owner=ALL&from=' + startDate.toISOString() + '&to=' + endDate.toISOString()).then(tickets => {
                    this.tickets = tickets.data;
                    console.info(this.tickets)
                }).catch(reason => {
                    console.error("Error al consultar los tickets", reason);
                }).finally(() => this.loading = false)

                Axios.getInstance().get('/api/unresolvedTickets?from=' + startDate.toISOString() + '&to=' + endDate.toISOString()).then(tickets => {
                    console.info("Resultado", tickets.data.length, tickets.data);
                    this.unresolvedTickets = tickets.data.map(t => {
                        let date = new Date(t.date);
                        date.setHours(0, 0, 0);
                        return {x: date.getTime(), y: t.count}
                    });
                }).catch(reason => {
                    console.error("Error al consultar los tickets", reason);
                })
            }
        },
        methods: {
            toggleTable() {
                this.showTable = !this.showTable;
            }
        },
        mounted() {
            this.loading = true;
            let endDate = new Date();
            let oneMonthInMillis = (30 * 24 * 60 * 60 * 1000);
            let startDate = new Date(endDate.getTime() - oneMonthInMillis)
            this.dates = [startDate, endDate]

        }
    }
</script>

<style lang="css">

    #app {
        font-family: OpenSans, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 60px;
    }
</style>

